import { FeatureHelperService } from './../_helpers/feature-helper/feature-helper.service';
import { ThemeService } from './../_helpers/theming-engine/theme.service';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '../_services/index';
import { MsalService } from '@azure/msal-angular';
import { environment } from '../../environments/environment';
import { SessionUserHashManagerService } from '../_services/session-user-hash-manager/session-user-hash-manager.service';
import { ErrorModalHelperService } from '../_helpers/error-modal-helper/error-modal-helper.service';
import { AuthenticationStateHelperService } from '../_helpers/authentication-state-helper/authentication-state-helper.service';


@Component({
    selector: 'automation-login',
    templateUrl: './automation-login.component.html',
    styleUrls: ['./automation-login.component.css'],
    standalone: false
})
export class AutomationLoginComponent implements OnInit {

  model: any = {};
  user: any = {};
  returnUrl: string;
  public companyType: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private msalService: MsalService,
    private authenticationService: AuthenticationService,
    public themeService: ThemeService,
    private featureHelperService: FeatureHelperService,
    private sessionHashService: SessionUserHashManagerService,
    private errorModalHelper: ErrorModalHelperService,
    private authenticationStateHelper: AuthenticationStateHelperService
    ) { }

  ngOnInit() {
    // reset login status
    if(this.msalService.instance.getAllAccounts().length > 0) {
      // Local sign-out only — see login.component.
      void this.msalService.instance.clearCache();
    }

    this.authenticationService.logout();

    this.sessionHashService.clearSessionHash();
    
    // get return url from route parameters or default to '/'
    this.authenticationStateHelper.returnUrl = this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';

    if (this.authenticationStateHelper.unauthorizedToken) {
      this.errorModalHelper.show("", {status: 401});
    }

    this.companyType = 'LEAP';
    this.themeService.setActiveTheme('LEAP', false);
  }

  login() {

    if(this.model.code == environment.automationLoginKey) {
    
      this.authenticationService.login(this.model.username, this.model.password, this.companyType).subscribe((data: any) => {
          this.user = data;
          if (this.user.tutorIds && this.user.tutorIds[0] == null) {
            this.user.tutorIds = [];
          }

          this.featureHelperService.setUserFeatures(data.userFeatures);
          this.authenticationService.setUser(this.user);
      
          setTimeout(() => {
            this.authenticationStateHelper.unauthorizedToken = false;
            this.router.navigateByUrl(this.returnUrl);
          }, 100);

      },
      error => {
        if (error.status === 0) {
          this.errorModalHelper.show("Internal system error, please contact the system administrator", error);
        } else {
          this.errorModalHelper.show(error.message, error);
        }
      });

    } else {      
      this.errorModalHelper.show("Code is not valid.", {isValidationError: true});
    }
  }

}
